import React, { useEffect, useState } from "react";
import { IconX, IconDeviceDesktop, IconDeviceMobile, IconArrowLeft } from "@tabler/icons-react";
import { KeyConstant, ImageConstant } from "const";
import { BranchUtils, StorageUtils } from "utils";
import localforage from "localforage";

const PreviewInformationDialog = ({ open, onClose, contentInformation }) => {
  const currentBranch = BranchUtils.getCurrentBranch();

  const [isScreenDesktop, setIsScreenDesktop] = useState(true);
  const [branchAvatar, setBranchAvatar] = useState("");

  useEffect(() => {
    const branchAttachmentId = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_ATTACHMENT);
    localforage.getItem(KeyConstant.KEY_CACHED_BRANCH_AVATAR_BLOB + branchAttachmentId).then(avatar => {
      if (avatar) setBranchAvatar(URL.createObjectURL(avatar));
    });
  }, []);

  if (!open) return null;

  return (
    <>
      <style>{`
        [data-bs-theme="dark"] .preview-content .ql-editor,
        [data-bs-theme="dark"] .preview-content .ql-editor * {
          color: var(--tblr-body-color) !important;
        }
        [data-bs-theme="dark"] .preview-content strong {
          color: var(--tblr-body-color) !important;
        }
      `}</style>
      <div className="modal-backdrop fade show"></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "1208px" }} role="document">
          <div className="modal-content" style={{ minHeight: "738px" }}>
            {/* Header with screen toggle */}
            <div className="modal-header py-2">
              <div className="d-flex justify-content-center flex-grow-1 gap-3">
                <button
                  className={`btn btn-ghost-secondary d-flex align-items-center gap-1 ${isScreenDesktop ? "text-primary border-bottom border-primary border-2" : ""}`}
                  onClick={() => setIsScreenDesktop(true)}
                >
                  <IconDeviceDesktop size={18} /> Máy tính
                </button>
                <button
                  className={`btn btn-ghost-secondary d-flex align-items-center gap-1 ${!isScreenDesktop ? "text-primary border-bottom border-primary border-2" : ""}`}
                  onClick={() => setIsScreenDesktop(false)}
                >
                  <IconDeviceMobile size={18} /> Di động
                </button>
              </div>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            {/* Content */}
            <div className="modal-body p-1 d-flex justify-content-center" style={{ backgroundColor: "var(--tblr-bg-surface-secondary)" }}>
              <div
                className="d-flex flex-column overflow-auto preview-content"
                style={{
                  backgroundColor: "var(--tblr-bg-surface)",
                  color: "var(--tblr-body-color)",
                  width: isScreenDesktop ? "1200px" : "360px",
                  height: isScreenDesktop ? "660px" : "640px",
                  paddingTop: isScreenDesktop ? "8%" : 0,
                  gap: "20px",
                }}
              >
                {!isScreenDesktop && (
                  <div className="d-flex justify-content-between align-items-center p-3">
                    <IconArrowLeft size={20} />
                    <strong style={{ fontSize: "15px" }}>Thông tin sản phẩm</strong>
                    <div style={{ width: "25px" }}></div>
                  </div>
                )}
                <div className="d-flex align-items-center justify-content-center gap-3">
                  <img
                    src={branchAvatar || ImageConstant.TriosLogo}
                    alt="Branch logo"
                    style={{
                      width: isScreenDesktop ? "100px" : "40px",
                      height: isScreenDesktop ? "100px" : "40px",
                      objectFit: "contain",
                    }}
                  />
                  <strong style={{ fontSize: isScreenDesktop ? "24px" : "16px" }}>
                    {currentBranch?.name}
                  </strong>
                </div>
                <div
                  className="ql-editor flex-grow-1"
                  style={{ height: "fit-content", overflowY: "unset" }}
                  dangerouslySetInnerHTML={{ __html: contentInformation }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreviewInformationDialog;
